import React, { useEffect, useState } from 'react';
import { useFetchye } from 'fetchye';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ProgressCircle, CardArt } from '@americanexpress/dls-react';

const Image = ({
  fieldId,
  imgProps,
  cssProperties = { style: '' },
  assetDimension,
  memberInfo,
  isCardArt = false,
  size = 'xl',
  isTilt = true,
}) => {
  const [imgSrc, setImgSrc] = useState('');
  const [isAssetLoading, setIsAssetLoading] = useState(false);
  const functionsApisUrls = useSelector((state) => state.getIn(['config', 'functionsApisUrls']));
  const digitalAssetId = memberInfo
    && memberInfo.digitalInfo
    && memberInfo.digitalInfo.digitalAssetId ? memberInfo.digitalInfo.digitalAssetId : '';
  const imageDimensions = imgProps && imgProps.assetDimensions ? imgProps.assetDimensions : null;

  const d = new Date();
  const ms = d.getMilliseconds();
  const clientId = 'iForms';
  const correlationId = clientId + ms;
  const reqtBody = [
    {
      assetId: digitalAssetId,
      assetDimension,
      // assetFormat: 'GIF',
      assetType: 'IMAGE',
      // assetStyle: 'STRAIGHT',
    },
  ];

  /**
 * fetch digitalAssets
 */
  const { run } = useFetchye(`${functionsApisUrls}/ReadDigitalAssets.v1`, {
    defer: true,
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'one-data-correlation-id': correlationId,
      // 'one-data-client-id': 'iForms',
      'ce-source': 'iForms',
    },
    body: JSON.stringify(reqtBody),
  });

  const fetchDigitalAssest = async () => {
    let imgSrcUrl = '';
    const { data: digitalAsset } = await run();
    if (digitalAsset && digitalAsset.body[0].assetDetails
      && digitalAsset.body[0].assetDetails.length > 0) {
      if (imageDimensions) {
        digitalAsset.body[0].assetDetails.forEach((asset) => {
          if (asset.assetDimension === imageDimensions) {
            imgSrcUrl = asset.assetUrl;
          }
        });
      }
      if (!imgSrcUrl) {
        imgSrcUrl = digitalAsset.body[0].assetDetails[0].assetUrl;
      }
      setIsAssetLoading(false);
      setImgSrc(imgSrcUrl);
    }
  };
  /*
  ** Any change to digitalAssetId captured here
  ** If digitalAssetId is null and there's no image src in prop, set imgSrc null
  */
  useEffect(() => {
    if (!imgProps.src && imgProps.fetchUrl === 'digitalAsset') {
      if (digitalAssetId) {
        setIsAssetLoading(true);
        fetchDigitalAssest();
      } else {
        setImgSrc(null);
      }
    } else {
      setImgSrc(imgProps.src);
    }
  }, [digitalAssetId, imgProps.src]);

  const imgComponent = imgProps.style ? (
    <img
      id={fieldId}
      title={imgProps.title}
      alt={imgProps.alt}
      src={imgSrc}
      style={{
        width: '100%', height: '50px', textAlign: 'center',
      }}
    />
  ) : (
    <img
      id={fieldId}
      title={imgProps.title}
      alt={imgProps.alt}
      src={imgSrc}
      className={imgProps.imageClass ? imgProps.imageClass : ''}
      style={{ maxWidth: imgProps.maxWidth ? `${imgProps.maxWidth}` : '100%' }}
    />
  );

  return (
    isAssetLoading ? (
      <div className="text-align-center width-full">
        <ProgressCircle />
      </div>
    )
      : imgSrc
      && (
        <div className={cssProperties.style}>
          {isCardArt ? (
            <CardArt size={size} tilt={isTilt}>
              {imgComponent}
            </CardArt>
          ) : imgComponent}
        </div>
      )
  );
};

Image.propTypes = {
  fieldId: PropTypes.string,
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  imgProps: PropTypes.objectOf(PropTypes.shape),
  assetDimension: PropTypes.string,
  memberInfo: PropTypes.objectOf(PropTypes.shape),
  isCardArt: PropTypes.bool,
  size: PropTypes.string,
  isTilt: PropTypes.bool,
};

export default Image;
